export default __webpack_public_path__ + "static/media/chart.e5c9bde3.svg";